module.exports = __webpack_public_path__ + "static/media/webdesign-services-img68.189b5b05.jpg";